import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#002EA6',
  layout: 'mix',
  contentWidth: 'Fluid',
  splitMenus: true,
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'SCRM',
  pwa: true,
  logo: 'https://wework.qpic.cn/wwpic3az/230088_-9bAEFQ5Rx6oYg8_1770188642/0',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
  menu: {
    defaultOpenAll: true,
    autoClose: false,
    locale: false,
    type: 'group',
  },
};

export default Settings;
